export default __webpack_public_path__ + "static/1237-ad674d2683c3b7ee8f9aca738e622c03.gif";